/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { HealthService } from './services/health.service';
import { AuthService } from './services/auth.service';
import { UserService } from './services/user.service';
import { MatchVideoService } from './services/match-video.service';
import { PreanalysisService } from './services/preanalysis.service';
import { VisionEventsService } from './services/vision-events.service';
import { WorkerService } from './services/worker.service';
import { CustomEliteConfigurationService } from './services/custom-elite-configuration.service';
import { BillingService } from './services/billing.service';
import { SuperadminService } from './services/superadmin.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    HealthService,
    AuthService,
    UserService,
    MatchVideoService,
    PreanalysisService,
    VisionEventsService,
    WorkerService,
    CustomEliteConfigurationService,
    BillingService,
    SuperadminService,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
